export default {
  NO_DATA: '@@first-sources/NO_DATA',
  GET_FIRST_SOURCES_REQUEST: '@@first-sources/GET_FIRST_SOURCES_REQUEST',
  GET_FIRST_SOURCES_SUCCESS: '@@first-sources/GET_FIRST_SOURCES_SUCCESS',
  GET_FIRST_SOURCES_ERROR: '@@first-sources/GET_FIRST_SOURCES_ERROR',
};
